module.exports = __webpack_public_path__ + "static/media/entregarinju.ff17a443.webp";